/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { isRightToLeft } from 'js/lib/language';

import CoachButton from 'bundles/unified-description-page-common/components/coach/CoachButton';

import _t from 'i18n!nls/unified-description-page-common';

const styles = {
  coachButtonContainer: ({ isRTL = false }: { isRTL: boolean }) => css`
    display: inline-flex;
    background: ${
      isRTL
        ? 'linear-gradient(90deg, rgb(53 135 252 / 40%) 0%, rgb(15 240 255 / 20%) 100%)'
        : 'linear-gradient(90deg, rgb(15 240 255 / 20%) 0%, rgb(53 135 252 / 40%) 100%)'
    };
    border-radius: var(--cds-border-radius-max);
    padding: var(--cds-spacing-50);
    align-items: center;
    justify-content: start;
  `,
  coachButton: css`
    .cds-button-label {
      white-space: nowrap;
    }
  `,
};

const CoachButtonInHeroModule = () => {
  const isRTL = isRightToLeft(_t.getLocale());

  return (
    <div css={styles.coachButtonContainer({ isRTL })}>
      <CoachButton css={styles.coachButton} />
    </div>
  );
};

export default CoachButtonInHeroModule;
